import React from "react";

const features = [
  {
    title: "Photorealistic AI Simulations",
    description:
      "Generated from the patient's actual face photo using dental AI technology",
    icon: "/icons/photo_realistic.png",
    highlighted: false,
  },
  {
    title: "Custom Shade Previews",
    description:
      "Patients compare veneer, implant, and whitening shade options side by side",
    icon: "/icons/custom_shade.png",
    highlighted: true,
  },
  {
    title: "Animated Smile Videos",
    description:
      "AI-generated video previews showing patients smiling, laughing, and interacting naturally",
    icon: "/icons/animated_video.png",
    highlighted: false,
  },
  {
    title: "Mobile-Friendly Sharing",
    description:
      "Patients view, share with family, and revisit their smile simulation from any device",
    icon: "/icons/mobile_friendly.png",
    highlighted: false,
  },
];

export default function SmileRevealSeconds() {
  return (
    <section id="ai-simulation" className="bg-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-8 lg:gap-9 items-center">
          <div className="max-w-[560px]">
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight leading-tight">
              AI Smile Simulation Software —<br />
              See Results in Seconds
            </h2>
            <p className="mt-5 text-slate-600 text-base">
              Instead of describing dental treatment outcomes, SmileReveal™ uses
              AI to instantly show patients what their smile will look like.
            </p>
          </div>

          <div className="relative w-full max-w-[680px] lg:justify-self-end">
            <div className="rounded-[999px] overflow-hidden h-[200px] sm:h-[235px] md:h-[255px] lg:h-[245px] shadow-sm border border-slate-200">
              <img
                src="/doctor_showing_transformation.jpg"
                alt="Dental team consultation meeting"
                width="1200"
                height="800"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute left-6 -bottom-4 bg-brand-600 text-white rounded-full px-4 py-2.5 shadow-md flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-white" />
              <span className="text-sm sm:text-base font-semibold leading-none">
                You’re showing the outcome.
              </span>
            </div>
          </div>
        </div>

        <p className="mt-9 text-2xl md:text-3xl text-slate-900 tracking-tight">
          SmileReveal™ uses AI to instantly generate:
        </p>

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {features.map((feature) => {
            return (
              <article
                key={feature.title}
                className={`rounded-3xl border p-5 sm:p-6 flex items-start gap-4 sm:gap-5 shadow-sm ${
                  feature.highlighted
                    ? "border-blue-100"
                    : "bg-white border-slate-200"
                }`}
                style={
                  feature.highlighted
                    ? {
                        background:
                          "linear-gradient(to right, #f0f9ff 40%, #3b82f6 200%)",
                      }
                    : {}
                }
              >
                <div
                  className="w-14 h-14 rounded-xl text-white flex items-center justify-center shrink-0 shadow-sm"
                  style={{
                    background:
                      "radial-gradient(circle at center, #3b82f6 0%, #0066ff 100%)",
                  }}
                >
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-6 h-6 sm:w-8 sm:h-8 object-contain p-0.5"
                  />
                </div>

                <div className="min-w-0">
                  <h3 className="text-base md:text-xl font-bold text-slate-900 leading-tight">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-slate-500 text-sm md:text-base leading-snug">
                    {feature.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
